import { Component, ElementRef, OnDestroy, OnInit, ViewChild, Inject, PLATFORM_ID, AfterViewInit } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { contentGet, loadContent, outlineContent } from 'src/interface/contentGet';
import { GetContentManagementDataService } from '../../services/get-content-management-data.service';
import { MainBodyService } from '../../services/main-body.service';
import { UserService } from 'src/app/user/user.service';
import { responsedata, themeData } from 'src/interface/themesetting';
import { PublisherService } from '../../services/publisher.service';
import { DomSanitizer, Meta, Title, SafeHtml } from '@angular/platform-browser';
import { JournalService } from '../journal.service';
import { EnvService } from 'src/app/services/env.service';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/services/shared.service';
import { SeoService } from 'src/app/services/seo.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
declare var gapi: any;
declare const google: any;
@Component({
    selector: 'app-load-content',
    templateUrl: './load-content.component.html',
    styleUrls: ['./load-content.component.scss']
})

export class LoadContentComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild('heading') heading: ElementRef<HTMLElement>
    @ViewChild('content') content: ElementRef<HTMLElement>
    @ViewChild('contentHeading') contentHeading: ElementRef<HTMLElement>
    contentData: loadContent = {
        page_heading: '',
        page_content: ''
    }
    contentGet: contentGet = {
        journal_id: '',
        page_name_id: '',
        language_key: ''
    };
    getPreviewContent = {
        journal_id: '',
        token: '',
    }
    fileDownload = {
        filename: ''
    }
    themeSettingsData: themeData;
    publisher_id: string;
    loading = true;
    headingMargin: string | number;
    parser: DOMParser;
    events = "ghnfhfdhfdb";
    activeline: boolean[] = [true];
    contentOutline: outlineContent[] = [{
        title: '',
        referance: ''
    }]
    timelineEvents: string[] = [
        "fdev", "fdsgderv", "dfegwrf", "dfwrtef"
    ];
    loaderContent = true;
    containerHeight = 0;
    routerParams: Params;
    subscriptionArr: Subscription[] = [];
    sanitizedContent: SafeHtml;
    constructor(
        private route: ActivatedRoute,
        private contentService: GetContentManagementDataService,
        public mainBodyService: MainBodyService,
        public userService: UserService,
        private publisherService: PublisherService,
        public sanitize: DomSanitizer,
        private journalService: JournalService,
        private router: Router,
        private titleService: Title,
        private meta: Meta,
        private EnvService: EnvService,
        private sharedService: SharedService,
        private seoService: SeoService,
        @Inject(PLATFORM_ID) private platformId: any,
        private googleAnalyticsService: GoogleAnalyticsService
    ) {
        if (isPlatformBrowser(this.platformId)) {
            this.parser = new DOMParser();
        }
        this.themeSettingsData = {
            journal_id: '',
            journal_logo: '',
            logo_alt_text: '',
            journal_banner: '',
            journal_display_name: '',
            banner_type: '',
            banner_heading: '',
            banner_content: '',
            banner_secondary_content: '',
            button_label: '',
            button_link: '',
            contact_us: {
                address_line_1: '',
                address_line_2: '',
                address_line_3: '',
                phone_number: 9123456789,
                email: ''
            },
            journal_about: '',
            social_media_links: [{
                label: 'Facebook link',
                key: 'facebook_link',
                icon: ['fab', 'facebook'],
                value: 'facebook.com',
            }],
            theme_colors: {
                button_color: '',
                button_text_color: '',
                primary_color: '',
                primary_footer_background_color: '',
                primary_footer_text_color: '',
                primary_header_background_color: '',
                primary_header_text_color: '',
                secondary_color: '',
                secondary_footer_background_color: '',
                secondary_footer_text_color: '',
                secondary_header_background_color: '',
                secondary_header_text_color: '',
                text_primary_color: '',
                text_secondary_color: ''
            },
            fullwidthcheck: '',
            transimagecheck: '',
            banner_transparent_image: '',
            banner_fullwidth_image: '',
            banner_full_alt_text: '',
            banner_trans_alt_text: '',
            about: '',
            journal_title: ''
        }
        this.timelineEvents = [
            "fdev", "fdsgderv", "dfegwrf", "dfwrtef"
        ];
    }

    ngOnInit(): void {
        const result = this.route.snapshot.data['contentData'];
        // this.loadGoogleApi()
        if (isPlatformBrowser(this.platformId)) {
            //this.getData();
            const resolvedData: any = this.route.snapshot.data['contentData'];
            if (resolvedData != undefined || null) {
                this.route.params.subscribe(params => {
                    this.routerParams = params;
                    if (params['page_name_id'] && params['token'] && params['languageCode']) {
                        this.getPreviewContent.journal_id = params['journal_id'];
                        this.getPreviewContent.token = params['token'];
                    }
                    else {
                        this.processData(resolvedData);
                    }
                });

            } else {
                this.route.params.subscribe(params => {
                    this.routerParams = params;
                    if (params['journal_id'] || params['page_name_id'] && params['token'] && params['languageCode']) {
                        this.getPreviewContent.journal_id = params['journal_id'];
                        this.getPreviewContent.token = params['token'];
                        const journalType = { jnl_type: "JNL" };
                        const getjournalsubs = this.journalService.getJournals(journalType).subscribe((result) => {
                            this.contentGet.journal_id = result.data[0].id;
                            this.getData();
                        });
                    }
                });
            }
            const fetchPubsubs = this.publisherService.fetchPublisherId().subscribe(response => {
                this.publisher_id = response[0].publisher_id;
                const language = localStorage.getItem('language')
                let languageCode: string = JSON.stringify(language)
                languageCode = this.removeQuotes(languageCode)
                this.contentGet.language_key = languageCode;
                this.mainBodyService.urlchange(true);
                const journalType = { jnl_type: "JNL" }
                this.journalService.getJournals(journalType).subscribe((result) => {


                    // this.metatag.updateTag(
                    //     { property: 'og:image', content: this.EnvService.imageUrl + 'themes/' + result.data[0].journal_cover_image },
                    // );
                });
                const routesubs = this.route.params.subscribe(params => {
                    //  this.getData()
                    this.loaderContent = true;
                    this.routerParams = params
                    if (params['journal_id'] || params['page_name_id'] && params['token'] && params['languageCode']) {
                        this.getPreviewContent.journal_id = params['journal_id'];
                        this.getPreviewContent.token = params['token'];
                        const journalType = { jnl_type: "JNL" }
                        const getjournalsubs = this.journalService.getJournals(journalType).subscribe((result) => {
                            this.contentGet.journal_id = result.data[0].id;
                            // this.metatag.updateTag(
                            //     { property: 'og:image', content: this.EnvService.imageUrl + 'themes/' + result.data[0].journal_cover_image },
                            // );
                            // this.getData()
                        });
                        this.subscriptionArr.push(getjournalsubs);
                        if (params['journal_id'] === this.publisher_id) {
                            this.mainBodyService.urlchange(false);
                        }
                        const getallthemesubs = this.mainBodyService.getAllThemeSettings(this.contentGet.journal_id).subscribe((result: responsedata) => {
                            if (result.status == 200) {
                                if (isPlatformBrowser(this.platformId)) {
                                    this.themeSettingsData = result.data;
                                    Object.entries(this.themeSettingsData.theme_colors).map(([key, value]) => {
                                        const element = "--" + key;
                                        const val = value;
                                        document.documentElement.style.setProperty(element, val);
                                    });
                                }
                            }
                        });
                        this.subscriptionArr.push(getallthemesubs);
                        this.getPreviewData(params['languageCode'])

                    }
                    else {
                        const journalType = { jnl_type: "JNL" }
                        if (params['journal_id'] == undefined)

                            this.journalService.getJournals(journalType).subscribe((result) => {
                                this.contentGet.journal_id = result.data[0].id;
                                this.journalService.journal_displayname = result.data[0].journal_display_name
                                // if (params['journal_id'] && params['page_name_id']) {
                                // this.contentGet.journal_id = params['journal_id'];
                                this.contentGet.page_name_id = params['page_name_id'];
                                if (params['journal_id'] === this.publisher_id) {
                                    this.mainBodyService.urlchange(false);
                                }
                                const getallthemesubs = this.mainBodyService.getAllThemeSettings(this.contentGet.journal_id).subscribe((result: responsedata) => {
                                    if (result.status == 200) {


                                        this.themeSettingsData = result.data;
                                        if (isPlatformBrowser(this.platformId)) {
                                            Object.entries(this.themeSettingsData.theme_colors).map(([key, value]) => {
                                                const element = "--" + key;
                                                const val = value;
                                                document.documentElement.style.setProperty(element, val);
                                            });
                                        }
                                    }
                                });
                                this.subscriptionArr.push(getallthemesubs);
                                this.getData();
                                // }
                            });
                    }
                });
                this.subscriptionArr.push(routesubs);
                const languagesubs = this.userService.languageChange$.subscribe(() => {
                    this.getData()
                })
                this.subscriptionArr.push(languagesubs);
            });
            this.subscriptionArr.push(fetchPubsubs);
        }
        const url = this.route.params.subscribe(params => {
            this.sharedService.setUrlParams(params);
        });
        this.subscriptionArr.push(url);

        //  this.destroyMetaTagsforSEONew();


    }

    removeQuotes(value: string): string {
        return value.replace(/['"]+/g, '');
    }
    // getData() {
    //     if (isPlatformBrowser(this.platformId)) {
    //         const getcurrentsubs = this.contentService.getCurrentContentData(this.contentGet).subscribe((result: any) => {
    //             this.loaderContent = false;
    //             if (result.data.length !== 0) {
    //                 const data = result.data[0].page;

    //                 this.seoService.createMetadataforSEONew(data);

    //                 // this.metatag.updateTag(
    //                 //     { property: 'og:url', content: this.EnvService.siteUrl + this.route.snapshot.url[0].path + '/' + result.data[0].page.page_name_id },
    //                 // );
    //                 const language = localStorage.getItem('language')
    //                 let languageCode: string = JSON.stringify(language)
    //                 languageCode = this.removeQuotes(languageCode)
    //                 if (data.page_heading) {
    //                     this.contentData.page_heading = data.page_heading[languageCode];
    //                     this.titleService.setTitle(this.contentData.page_heading + ' | ' + this.journalService.journal_displayname)
    //                    // this.createMetadataforSEONew(this.contentData.page_heading );
    //                     // this.metatag.updateTag(
    //                     //     { property: 'og:title', content: this.contentData.page_heading + ' | ' + this.journalService.journal_displayname },
    //                     // );
    //                     // this.metatag.updateTag(
    //                     //     { property: 'og:type', content: 'Content' },
    //                     // );

    //                     this.setLineMargin()
    //                 }
    //                 if (data.page_content) {
    //                     const html = this.parser.parseFromString(data.page_content[languageCode], 'text/html');                        
    //                     this.contentData.page_content = data.page_content[languageCode]
    //                     // const html = this.parser.parseFromString(this.contentData.page_content, 'text/html');
    //                     const contentTangs = html.getElementsByTagName('a');

    //                     Array.from(contentTangs).forEach(element => {
    //                         element.setAttribute('target', '_blank')
    //                     });
    //                     const serializer = new XMLSerializer();
    //                     this.contentData.page_content = serializer.serializeToString(html);
    //                     // this.contentData.page_content= ɵ_sanitizeHtml
    //                     // this.content.nativeElement.innerHTML= this.contentData.page_content;
    //                     // const lines = this.contentData.page_content.split('\n');
    //                     // const firstThreeLines = lines.slice(0, 3);
    //                     const firstThreeLines = this.contentData.page_content
    //                         .replace(/<[^>]*>/g, '') // Remove HTML tags
    //                         .split(/[.!?]/) // Split into sentences
    //                         .filter(sentence => sentence.trim() !== '') // Remove empty sentences
    //                         .slice(0, 3) // Take the first three sentences
    //                         .join('\n'); // Join with newline
    //                         //this.createMetadataforSEONew(firstThreeLines);
    //                     //  this.metatag.updateTag({ property: 'og:description', content: firstThreeLines });

    //                 }
    //             }
    //             else {
    //                 this.router.navigate(['/**']);
    //             }
    //         });
    //         this.subscriptionArr.push(getcurrentsubs);
    //     }
    // }
    getData() {
        const getcurrentsubs = this.contentService.getCurrentContentData(this.contentGet).subscribe((result: any) => {
            this.loaderContent = false;
            if (result.data.length !== 0) {
                this.processData(result);
            } else {
                this.router.navigate(['/**']);
            }
        });
        this.subscriptionArr.push(getcurrentsubs);
    }

    processAnchorLinks(pageContent: string): string {
        const html = new DOMParser().parseFromString(pageContent, 'text/html');
        const contentTags = html.getElementsByTagName('a');

        Array.from(contentTags).forEach(element => {
            const href = element.getAttribute('href');
            if (href && !href.startsWith('#')) {
                element.setAttribute('target', '_blank');
            } else if (href && href.length > 1) {
                const currentUrl = window.location.href.split('#')[0];
                element.setAttribute('href', currentUrl + href);
            }
        });

        const serializer = new XMLSerializer();
        return serializer.serializeToString(html);
    }

    processData(result: any) {
        const data = result.data[0].page;

        this.seoService.createMetadataforSEONew(data);

        const language = localStorage.getItem('language');
        let languageCode: string = JSON.stringify(language);
        languageCode = this.removeQuotes(languageCode);
        if (data.page_heading) {
            this.contentData.page_heading = data.page_heading[languageCode];
            this.titleService.setTitle(this.contentData.page_heading + ' | ' + this.journalService.journal_displayname);
            this.setLineMargin();
        }

        if (data.page_content) {
            this.contentData.page_content = data.page_content[languageCode];
            this.contentData.page_content = this.processAnchorLinks(this.contentData.page_content);

            const firstThreeLines = this.contentData.page_content
                .replace(/<[^>]*>/g, '') // Remove HTML tags
                .split(/[.!?]/) // Split into sentences
                .filter(sentence => sentence.trim() !== '') // Remove empty sentences
                .slice(0, 3) // Take the first three sentences
                .join('\n');
            this.sanitizedContent = this.structuringData(this.contentData.page_content);

        }
    }

    //   private removeQuotes(value: string): string {
    //     return value.replace(/^"(.*)"$/, '$1');
    //   }
    setLineMargin() {
        if (isPlatformBrowser(this.platformId)) {
            setTimeout(() => {
                this.headingMargin = this.heading?.nativeElement.clientHeight as number
                if (this.headingMargin > 40)
                    this.headingMargin = (this.headingMargin / 2) + 'px';
                else
                    this.headingMargin = (this.headingMargin - 10) + 'px';
                document.documentElement.style.setProperty('--heading-margin', this.headingMargin);
            }, 500);
        }


    }
    getPreviewData(language: string) {
        const journalType = { jnl_type: "JNL" }
        if (this.routerParams['journal_id'] == undefined) {
            this.journalService.getJournals(journalType).subscribe((result) => {
                this.getPreviewContent.journal_id = result.data[0].id;

                this.previewSubscription(language)
            })
        }
        else {
            this.previewSubscription(language)
        }
    }
    previewSubscription(language: string) {

        const getpreviewsubs = this.contentService.getPreviewContentData(this.getPreviewContent).subscribe((result: any) => {
            if (result) {
                const data = result.data[0].page;
                const languageCode = language;
                if (data.temp_page_heading) {
                    this.contentData.page_heading = data.temp_page_heading[languageCode];
                    this.setLineMargin();
                }
                if (data.temp_page_content) {
                    this.contentData.page_content = data.temp_page_content[languageCode];
                    this.contentData.page_content = this.processAnchorLinks(this.contentData.page_content);
                    this.sanitizedContent = this.structuringData(this.contentData.page_content);
                }
                this.loaderContent = false;
            }
        });
        this.subscriptionArr.push(getpreviewsubs);
    }
    // getContentOutline() {

    //     return true;

    // }
    // structuringData(data: string) {
    //     const regexMap = {
    //         '<em>': '<em>',
    //         '</em>': '</em>',
    //         '<strong>': '<strong>',
    //         '</strong>': '</strong>',
    //         '<addr-line': "<span class='affil'",
    //         '</addr-line>': '</span>',
    //         '<institution': "<span class='affil'",
    //         '</institution>': '</span>',
    //         '<country': "</span class='affil'",
    //         '</country>': '</span>',
    //         '<email': "<span class='affil'",
    //         '</email>': '</span>',
    //     };
    //     // Object.entries(regexMap).forEach(([pattern, replacement]) => {
    //     //     data = data.replace(new RegExp(pattern, 'gmi'), replacement);
    //     // });
    //     if (typeof data === 'string') {
    //         Object.entries(regexMap).forEach(([pattern, replacement]) => {
    //             data = data.replace(new RegExp(pattern, 'gmi'), replacement);
    //         });
    //     }

    //     return this.sanitize.bypassSecurityTrustHtml(data);
    // }

    structuringData(data: string): SafeHtml {
        const regexMap = {
            '<em>': '<em>',
            '</em>': '</em>',
            '<strong>': '<strong>',
            '</strong>': '</strong>',
            '<addr-line': "<span class='affil'",
            '</addr-line>': '</span>',
            '<institution': "<span class='affil'",
            '</institution>': '</span>',
            '<country': "</span class='affil'",
            '</country>': '</span>',
            '<email': "<span class='affil'",
            '</email>': '</span>',
        };

        let sanitizedData: string = data;

        if (typeof data === 'string') {

            // ✅ Remove role attribute ONLY from <li> tags
            sanitizedData = sanitizedData.replace(
                /<li([^>]*)\srole=["'][^"']*["']([^>]*)>/gi,
                '<li$1$2>'
            );

            Object.entries(regexMap).forEach(([pattern, replacement]) => {
                sanitizedData = sanitizedData.replace(new RegExp(pattern, 'gmi'), replacement);
            });
        }

        const sanitizedHtml: SafeHtml = this.sanitize.bypassSecurityTrustHtml(sanitizedData);
        return sanitizedHtml;
    }
    goToPage(url: string) {
        this.router.navigate([url])
    }

    onContentClick(event: Event): void {
        const target = event.target as HTMLElement;
        const anchor = target.closest('a');
        if (!anchor) {
            return;
        }
        const href = anchor.getAttribute('href');
        if (!href || !href.includes('#')) {
            return;
        }
        const [path, id] = href.split('#');
        const currentPath = window.location.href.split('#')[0];
        if (id && (path === '' || path === currentPath)) {
            event.preventDefault();
            const el = document.getElementById(id);
            if (el) {
                const headerHeight = document.getElementById('header')?.offsetHeight || 0;
                const top = el.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
                window.scrollTo({ top, behavior: 'smooth' });
                history.pushState(null, '', currentPath + '#' + id);
            }
        }
    }

    public destroyMetaTagsforSEONew() {
        // this.metatag.updateTag(
        //     { property: 'og:url', content: this.EnvService.siteUrl },
        // );
        // this.metatag.updateTag(
        //     { property: 'og:title', content: this.contentData.page_heading + ' | ' + this.journalService.journal_displayname },
        // );
        // this.metatag.updateTag(
        //     { property: 'og:description', content: "Journal of the British Academy" },
        // );
        // this.metatag.updateTag(
        //     { property: 'og:image', content: this.EnvService.imageUrl + "themes/default_logo.png" },
        // );
        // this.metatag.updateTag(
        //     { property: 'twitter:title', content: "Journal of the British Academy" },
        // );
        // this.metatag.updateTag(
        //     { property: 'twitter:description', content: "Journal of the British Academy" },
        // );
        // this.metatag.updateTag(
        //     { property: 'twitter:image', content: this.EnvService.imageUrl + "themes/default_logo.png" },
        // );
    }

    ngAfterViewInit() {
        if (isPlatformBrowser(this.platformId)) {
            const elementHeader = (<HTMLInputElement>document.getElementById("footer"));
            const elementFooter = (<HTMLInputElement>document.getElementById("footer"));
            if ((typeof (elementHeader) != 'undefined' && elementHeader != null) && (typeof (elementFooter) != 'undefined' && elementFooter != null)) {

                const headerHeight = (<HTMLInputElement>document.getElementById("header")).clientHeight;
                const fotterHeight = (<HTMLInputElement>document.getElementById("footer")).clientHeight;
                this.containerHeight = window.innerHeight - (fotterHeight + headerHeight);
            }
        }
    }
    // public createMetadataforSEONew(data) {
    //     console.log(data);
    //     const language = localStorage.getItem('language')
    //     let languageCode: string = JSON.stringify(language)
    //     languageCode = this.removeQuotes(languageCode)              
    //     this.contentData.page_heading = data.temp_page_heading[languageCode];
    //     const html = this.parser.parseFromString(data.page_content[languageCode], 'text/html');                        
    //     this.contentData.page_content = data.page_content[languageCode]
    //     // const html = this.parser.parseFromString(this.contentData.page_content, 'text/html');
    //     const contentTangs = html.getElementsByTagName('a');

    //     Array.from(contentTangs).forEach(element => {
    //         element.setAttribute('target', '_blank')
    //     });
    //     const serializer = new XMLSerializer();
    //     this.contentData.page_content = serializer.serializeToString(html);
    //     const content = this.contentData.page_content
    //     .replace(/<[^>]*>/g, '') // Remove HTML tags
    //     .split(/[.!?]/) // Split into sentences
    //     .filter(sentence => sentence.trim() !== '') // Remove empty sentences
    //     .slice(0, 5) // Take the first three sentences
    //     .join('\n');
    //     console.log(content)
    //     this.meta.updateTag(
    //         { property: 'og:url', content: this.EnvService.siteUrl + 'content/'+data.page_identifier },
    //     );
    //     this.meta.updateTag(
    //         { property: 'og:type', content: 'content' },
    //     );
    //     this.meta.updateTag(
    //         { property: 'og:title',content:this.contentData.page_heading + ' | ' + this.journalService.journal_displayname}
    //     );
    //      this.meta.updateTag(
    //         { property: 'og:description', content: content},
    //     );
    //     // this.meta.addTags([
    //     //     { name: 'citation_title', content: articledata.article_title.replace(/<[^>]*>/g, '') },
    //     //     { name: 'citation_abstract', content: articledata.abstract.replace(/<[^>]*>/g, '') },
    //     //     { name: 'citation_journal_title', content: articledata.journal_title },
    //     //     { name: 'citation_doi', content: articledata.doi },
    //     //     { name: 'article_type', content: articledata.article_type },
    //     //     { name: 'citation_volume', content: articledata.volume },
    //     //     { name: 'citation_publisher', content: articledata.publisher_name },
    //     //     { name: 'article_publisher_location', content: articledata.publisher_loc },
    //     //     { name: 'article_subject_heading', content: articledata.subject_heading },
    //     //     { name: 'citation_keywords', content: articledata.keywords != undefined ? articledata.keywords.join(';') : '' },
    //     //     { name: 'article_meta', content: articledata.article_meta != undefined ? articledata.article_meta : '' },
    //     //     { name: 'citation_abstract_html_url', content: this.env.siteUrl + 'articles/' + articledata.article_id },
    //     //     { name: 'citation_article_url', content: this.env.siteUrl + 'articles/' + articledata.article_id },
    //     // ]);
    //     // let imageUrl: string
    //     // if (articledata.article_cover_image)
    //     //     imageUrl = this.articleCoverImageUrl + articledata.volume_id + '/' + articledata.issue_id + '/' + articledata.article_id + '/' + articledata.article_cover_image;
    //     // else
    //     //     imageUrl = this.env.defaultImagePath + this.env.default_articleCoverImage;

    //     // this.meta.updateTag(
    //     //     { property: 'og:url', content: this.env.siteUrl + '/articles/' + articledata.volume_id + '/' + articledata.issue_id + '/' + articledata.article_id },
    //     // );
    //     // this.meta.updateTag(
    //     //     { property: 'twitter:title', content: articledata.article_title.replace(/<[^>]*>/g, '') },
    //     // );
    //     // this.meta.updateTag(
    //     //     { property: 'og:description', content: articledata.article_title.replace(/<[^>]*>/g, '') },
    //     // );
    //     // this.meta.updateTag(
    //     //     { property: 'twitter:description', content: articledata.article_title.replace(/<[^>]*>/g, '') },
    //     // );
    //     // // this.meta.updateTag(
    //     // //     { property: 'og:image', content: imageUrl },
    //     // // );
    //     // this.meta.updateTag(
    //     //     { property: 'og:type', content: articledata.article_type.replace(/<[^>]*>/g, '') },
    //     // );
    //     // this.meta.updateTag(
    //     //     { property: 'og:title', content: articledata.article_title },
    //     // );
    //     // this.meta.updateTag(
    //     //     { property: 'og:description', content: articledata.article_title },
    //     // );
    //     // this.meta.updateTag(
    //     //     { property: 'twitter:image', content: imageUrl },
    //     // );

    // }

    ngOnDestroy() {
        this.destroyMetaTagsforSEONew();
        this.subscriptionArr.forEach(x => {
            if (!x.closed) {
                x.unsubscribe();
            }
        });
    }

    //     signIn() {
    //         this.googleAnalyticsService.signIn();
    //       }
}